import { green, orange } from '@mui/material/colors';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Chip } from 'shared/mui/Chips';

export type ArchiveConditionListChipProps = {
  archive: boolean;
  archiveLabel?: string;
  activeLabel?: string;
};

export const ArchiveConditionListChip: React.FC<ArchiveConditionListChipProps> = ({
  archive,
  archiveLabel,
  activeLabel,
}) => {
  const translate = useTypedTranslate();

  const label = archive
    ? (archiveLabel ?? translate('app.statuses.archive'))
    : (activeLabel ?? translate('app.statuses.active'));

  return (
    <Chip
      color="primary"
      label={label}
      size="small"
      sx={{
        background: archive ? orange[800] : green[800],
      }}
    />
  );
};
